// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__bWwAO","infoBtn":"quickbooks_infoBtn__Ozuz7","formBox":"quickbooks_formBox__3QVMF","formFooter":"quickbooks_formFooter__3KHGV"};